import React, { useEffect, useState } from 'react'
import './ShopByCategory.css'
import CMSHead from '../../UI-Controls/CMSHead/CMSHead';
import CategoryDropdown from '../../UI-Controls/CategoryDropdown/CategoryDropdown';
import InfoPopUp from '../../InfoPopUp/InfoPopUp';
import axios from 'axios';
import { security_key, Url } from '../../../Services/Api';
import { LuPlus } from 'react-icons/lu';
import AddButton from '../../UI-Controls/AddButton/AddButton';
import SectionLoader from '../../UI-Controls/MainLoader/SectionLoader';

const ShopByCategory = ({ handleOpen }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [categoryPayload, setCategoryPayload] = useState({
    "sectional_schema": {
      "shop_by_category": []
    }
  })
  const [selectCategoryData, setSelectedCategoryData] = useState([])
  const [categoryUid, setCategoryUid] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategoryData = async () => {
      // const api = `/api/v1/productCategory/get?parent=0`;
      const api = `/api/v1/productCategory/get`;
      try {
        const response = await axios.get(`${Url + api}`)
        setSelectedCategoryData(response.data.categories);
      } catch (error) {
        console.error("error fetching categories", error);
      }
    }
    fetchCategoryData()
  }, [])

  const handleShowInfoModal = () => {
    setInfoModal(true)
  }

  const handleCloseInfoModal = () => {
    setInfoModal(false);
  }

  const toggleDropdown = (index) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  useEffect(() => {
    const getSelectedCategories = async () => {
      const api = `/api/v1/content1/get`
      try {
        const response = await axios.get(`${Url + api}`);
        setSelectedCategories(response.data.landingPageContent.sectional_schema.shop_by_category)
      } catch (error) {
        console.log('Error geting selected categories', error);
      }
    }
    getSelectedCategories()
  }, [])

  const handleSelect = (index, category) => {
    const newCategory = [...selectedCategories];
    newCategory[index] = category;
    setSelectedCategories(newCategory);

    setCategoryUid((prevCategoryUid) => {
      const updatedUids = new Set(prevCategoryUid);
      updatedUids.add(category.uid);
      return Array.from(updatedUids);
    });

    setDropdownOpen(false);
  };

  useEffect(() => {
    const initialUids = selectedCategories.map((cat) => cat.uid).filter(Boolean);

    setCategoryUid((prevCategoryUid) => {
      const updatedUids = new Set([...prevCategoryUid, ...initialUids]);
      return Array.from(updatedUids);
    });
  }, [selectedCategories]);

  const addDropdown = () => {
    setSelectedCategories((prev) => [...prev, ''])
  }

  const deleteDropdown = (index, categoryId) => {
    setSelectedCategories((prev) => {
      const updatedCategories = prev.filter((_, i) => i !== index);
      return updatedCategories;
    });

    setCategoryUid((prevCategory) => {
      const updatedUids = prevCategory.filter((uid) => uid !== categoryId);
      return updatedUids;
    });
  }

  const updateCategoryUid = async () => {

    const updatedPayload = {
      sectional_schema: {
        shop_by_category: categoryUid
      },
    };

    setCategoryPayload(updatedPayload);

    const api = `/api/v1/content1/edit`
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };

    try {
      setLoading(true);
      await axios.put(`${Url + api}`, updatedPayload,{headers:headers})
        .then(response => console.log("set category succesfull", response))
        .catch(error => console.log("error category updating", error))

      handleOpen('set category successful')
    } catch (error) {
      console.error("error updating categories", error);
      handleOpen('error updating categories')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='CategoryMainSection'>
      <CMSHead
        heading={'Shop By Category'}
        buttonText={'Save'}
        isButtonVissible={true}
        sendImagesHomeSlider={updateCategoryUid}
        handleShowInfoModal={handleShowInfoModal}
      />
      <div className='CategoryBody'>
        {loading && <SectionLoader />}
        <p className='category-heading'>Select Category</p>
        <div className='category-fropdown-and-button'>
          <CategoryDropdown
            selectCategoryData={selectCategoryData}
            selectedCategories={selectedCategories}
            toggleDropdown={toggleDropdown}
            dropdownOpen={dropdownOpen}
            handleSelect={handleSelect}
            deleteDropdown={deleteDropdown}
          />
          <div className='add-category-btn-div'>
            <AddButton
              handleClick={addDropdown}
              iconShow={true}
              icon={<LuPlus color='#4487C5' size={20} />}
              text={'Add'}
              rowDirection={'row'}
            />
          </div>
        </div>
      </div>
      <InfoPopUp
        showInfoModal={infoModal}
        handleCloseInfoModal={handleCloseInfoModal}
      />
    </div>
  )
}

export default ShopByCategory